// DASH.C1 (#825) — map a stored landing preference to a client route. Shared by
// LoginPage (post-login routing) and LandingModal (Continue navigation) + the
// Settings dropdown options, so the mapping can't drift from the API enum.

export type LandingPage = 'dashboard' | 'projects' | 'last_project' | 'notifications';

export const LANDING_PAGES: LandingPage[] = ['dashboard', 'projects', 'last_project', 'notifications'];

export const LANDING_LABELS: Record<LandingPage, string> = {
  dashboard:     'Dashboard',
  projects:      'Projects',
  last_project:  'Last visited project',
  notifications: 'Notifications',
};

// Role-default pre-selection for the first-login modal (#825 AC). Keyed off the
// resolved DashboardRole: Platform/Tenant Admin/PM → dashboard, Developer →
// last_project, Partner/Client → notifications.
export function defaultLandingForRole(role: string): LandingPage {
  switch (role) {
    case 'developer':    return 'last_project';
    case 'partner':
    case 'client':       return 'notifications';
    default:             return 'dashboard';   // platform_admin / tenant_admin / pm
  }
}

// Resolve a preference to a route. Unknown/null → /projects (the established
// login fail-safe). 'last_project' falls back to /projects when the user has no
// resolved last project.
export function resolveLandingRoute(
  pref: LandingPage | string | null | undefined,
  lastProjectId: string | null | undefined,
): string {
  switch (pref) {
    case 'dashboard':    return '/dashboard';
    case 'projects':     return '/projects';
    case 'last_project': return lastProjectId ? `/projects/${lastProjectId}` : '/projects';
    // 'notifications': no dedicated notifications PAGE route exists yet (the bell
    // dropdown is the only surface — see DashboardZone2Action's gated "View all").
    // Route to /dashboard (which carries the notifications preview) until that
    // page ships. Forward-compatible: change this one line when /notifications lands.
    case 'notifications': return '/dashboard';
    default:              return '/projects';
  }
}
